export const noop = () => {
};

export const openLink = (url: string, target: string = '_blank') => {
  const link = document.createElement('a');
  link.href = url;
  link.target = target;
  link.click();
};

export const ifTrue = (val: boolean): <T>(arg: T) => T|undefined => {
  return (arg) => val ? arg : undefined;
}

export const ifFalse = (val: boolean): <T>(arg: T) => T|undefined => {
  return ifTrue(!val);
}
